export default __webpack_public_path__ + "static/logo2-83a893754c847ee221df17f20aa8a75e.png";